import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
const CustomerCountChart = ({ title, data, xAxisKey, xLabel }) => {
  const maxCount = Math.max(...data.map((item) => item.count), 0);
  const yAxisMax = Math.ceil(maxCount);  
  const getInterval = () => {
    if (data.length <= 7) return 0; 
    if (data.length <= 31) return Math.floor(data.length / 31);
    return Math.floor(data.length / 11); 
  };
  return (
    <div style={{ width: "90%", height: 260 }}>
      <h3>{title}</h3>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey={xAxisKey}
            interval={getInterval()}
            label={{ value: xLabel, position: "insideBottomRight", offset: -5 }}
            tick={data.length > 15 ? { angle: -1, dy: 10 } : {}}
          />
          <YAxis
            domain={[0, yAxisMax]}
            allowDecimals={false}
            tickFormatter={(value) => Math.floor(value).toString()}
            label={{ value: "Customers", angle: -90, position: "insideLeft" }}
          />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomerCountChart;
